// R-CAP-06: raw capture input is persisted locally BEFORE any network call and synced when online.
import { get, set, del, keys } from "idb-keyval";
import type { CaptureInput } from "../api/types";

export type QueuedCapture = { id: string; clientId: string; input: CaptureInput; queuedAt: string; attempts: number };
const PREFIX = "cb-capture:";

export async function enqueueCapture(clientId: string, input: CaptureInput): Promise<QueuedCapture> {
  const q: QueuedCapture = { id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`, clientId, input: { ...input, clientLocalId: input.clientLocalId ?? crypto.randomUUID() }, queuedAt: new Date().toISOString(), attempts: 0 };
  await set(PREFIX + q.id, q);
  return q;
}
export async function removeCapture(id: string) { await del(PREFIX + id); }
export async function listQueued(): Promise<QueuedCapture[]> {
  const ks = (await keys()).filter((k): k is string => typeof k === "string" && k.startsWith(PREFIX));
  const out: QueuedCapture[] = [];
  for (const k of ks) { const v = await get<QueuedCapture>(k); if (v) out.push(v); }
  return out.sort((a, b) => a.queuedAt.localeCompare(b.queuedAt));
}
/** Try to sync every queued capture. Returns the ids that succeeded. */
export async function syncQueued(send: (q: QueuedCapture) => Promise<unknown>): Promise<string[]> {
  if (typeof navigator !== "undefined" && !navigator.onLine) return [];
  const done: string[] = [];
  for (const q of await listQueued()) {
    try { await send(q); await removeCapture(q.id); done.push(q.id); }
    catch { q.attempts += 1; await set(PREFIX + q.id, q); }
  }
  return done;
}
